import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import type { UserCustomAttribute } from 'shared-types';

interface Props {
  attribute: UserCustomAttribute;
  updateData: () => Promise<void>;
}

const UserAttributesOptionsAddGroup = ({ attribute, updateData }: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    const data = {
      optionGroups: [
        ...attribute.optionGroups,
        {
          conditions: [],
          options: [],
          sort: 'manual'
        }
      ]
    };

    await api.put(`/admin/user-custom-attributes/${attribute.id}`, data);

    await updateData();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonAdd}
      buttonCategory="light"
      buttonIcon="plus"
      buttonSize="header"
      buttonText={'Add option group'}
      category="success"
      confirmText={'Are you sure you want to add a new option group?'}
      confirmTitle={'Add option group'}
      onConfirm={handleConfirm}
      successMessage={messages.commonChangesSavesSuccessfully}
    />
  );
};

export default UserAttributesOptionsAddGroup;
